var map = {
	"./Dashboard.tsx": 462,
	"./Declare.tsx": 460,
	"./Edumain.tsx": 441,
	"./Eduresult.tsx": 458,
	"./Exam.tsx": 459,
	"./Faq.tsx": 442,
	"./Intro.tsx": 443,
	"./Login.tsx": 444,
	"./Mudlogin.tsx": 445,
	"./Mudmanage.tsx": 447,
	"./Mypage.tsx": 448,
	"./Target.tsx": 461,
	"./Template.tsx": 455
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 969;